import { secureApi } from '../Config/api'
import { GET, POST } from './apis'
import { authToken, removeToken, removeUser, setNotificationFlag } from '../Redux/actions/authActions'
import paths from '../Config/paths'
import { employeeLog, employeeLogSummary, employeeName } from '../Redux/actions/employeeActions'
import { setAnalyticsFilter } from '../Redux/actions/analyticsFilterActions'

import axios from 'axios'
import { message } from 'antd'
import { setEstimationData, setEstimationLoading, setEstimationSummary } from '../Redux/actions/estimationActions'
import { setStats } from '../Redux/actions/statsActions'
import moment from "moment-timezone"

const handleLogout = async (history, dispatch) => {
    try {
        dispatch(removeUser())
        dispatch(removeToken())
        dispatch(setNotificationFlag(false))

        history.push(paths?.LOGIN)
    } catch (err) {
        // console.error('Error during logout:', err)
    }
}

export const convertLocalToItalianTime = (time, selectedDate) => {
    try {
        let parsedTime

        const date = selectedDate ? moment(selectedDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD")

        if (typeof time === "string" && /^\d{2}:\d{2}(:\d{2})?$/.test(time)) {
            parsedTime = moment.tz(
                `${date} ${time}`,
                time.length === 5 ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD HH:mm:ss",
                moment.tz.guess()
            )
        } else if (moment.isMoment(time)) {
            parsedTime = moment.tz(
                `${date} ${time.format("HH:mm:ss")}`,
                "YYYY-MM-DD HH:mm:ss",
                moment.tz.guess()
            )
        } else if (time instanceof Date) {
            parsedTime = moment(time)
        } else {
            parsedTime = moment()
        }

        return parsedTime.tz("Europe/Rome")
    } catch (err) {
        console.error("Error in convertLocalToItalianTime:", err)
        return moment().tz("Europe/Rome")
    }
}

export const convertItalianToLocalTime = (italyTime) => {
    if (!italyTime) return null
    try {
        let fullTime = italyTime
        if (/^\d{2}:\d{2}(:\d{2})?$/.test(italyTime)) {
            const today = moment().tz("Europe/Rome").format("YYYY-MM-DD")
            fullTime = `${today} ${italyTime}`
        }
        return moment.tz(fullTime, "YYYY-MM-DD HH:mm:ss", "Europe/Rome").local()
    } catch (err) {
        console.error("Error converting Italian time to local:", err)
        return null
    }
}

const verifyToken = async (history, dispatch) => {
    try {
        const data = await secureApi.get(GET?.VERIFY_TOKEN)
        // console.log('verifyToken data', data)
        if (data?.status === 429 || data?.message === "Too many requests, please try again later.") {
            message.error("Too many requests Please try again later.")
            return true
        }
        if (!data?.success) {
            // console.error('Token verification failed. Redirecting to login...')
            handleLogout(history, dispatch)
            return false
        } else {
            dispatch(authToken(data?.accessToken))
            return true
        }
    } catch (error) {
        console.error('Error verifying token:', error)
        // handleLogout(history, dispatch)
        // return false
    }
}

const updateFcmToken = async (userId, fcmToken) => {
    try {
        const data = await secureApi.post(POST?.UPDATE_FCM_TOKEN, { userId, fcmToken })
        // console.log('fcm token response', data)
    }
    catch (error) {
        console.error('Error verifying token:', error)
        // handleLogout(history, dispatch)
        // return false
    }
}

const fetchEmployeeLog = async ({ dispatch, dateRange, selectedOption, user, page = 1, limit = 10 }) => {
    try {
        const response = await secureApi.get(GET?.GET_EMPLOYE_LOG, {
            params: {
                dateRange: {
                    start: dateRange?.[0]?.format('YYYY-MM-DD'),
                    end: dateRange?.[1]?.format('YYYY-MM-DD')
                },
                selectedOption,
                user_id: user?.id,
                role: user?.role,
                page,
                limit
            }
        })

        // console.log('response', response)
        if (response?.success) {
            dispatch(employeeLog(response?.data))
            dispatch(employeeLogSummary({
                ...response?.summary,
                indicators: response?.indicators,
                pagination: {
                    currentPage: response?.currentPage,
                    totalPages: response?.totalPages,
                    totalRecords: response?.totalRecords
                }
            }))
        }
        else {
            dispatch(employeeLog([]))
            dispatch(employeeLogSummary([]))
            console.error('Failed to fetch employee logs:', response?.message)
        }

    }
    catch (error) {
        console.error('Error fetching employee logs:', error)
    }
}

const fetchEmployeeName = async ({ dispatch, user }) => {
    try {
        const response = await secureApi.get(GET?.GET_EMPLOYEE_NAME, {
            params: {
                user_id: user?.id,
                role: user?.role,
            }
        })
        // console.log(response, 'response')

        if (response?.success) {
            dispatch(employeeName(response?.data))
        }
        else {
            console.error('Failed to fetch employee logs:', response?.message)
        }

    } catch (error) {
        console.error('Error fetching employee logs:', error)
    }
}

const fetchEstimations = async ({ user, dispatch, vehicleId }) => {
    if (!user?.id) return
    try {
        dispatch(setEstimationLoading(true))
        const res = await secureApi?.get(`${GET?.GET_ESTIMATION_DATA}?vehicle_id=${vehicleId}`)

        // console.log(res, 'res fetchEstimations')
        if (res?.success) {
            dispatch(setEstimationData(res?.data || []))
            dispatch(setEstimationSummary(res?.summary || []))

        } else {
            message.error(res?.message || "Failed to load estimations")
            dispatch(setEstimationLoading(false))
        }
    } catch (err) {
        message.error("Error fetching estimations")
        dispatch(setEstimationLoading(false))
    }
}

const fetchStats = async ({ dispatch, user, vehicleId }) => {
    try {
        const res = await secureApi?.get(`${GET?.GET_ESTIMATION_STATS}?vehicle_id=${vehicleId}`)
        if (res?.success) {
            dispatch(setStats({
                units: res?.data?.units || 0,
                systems: res?.data?.systems || 0,
                totalCost: res?.data?.totalCost || 0,
            }))
        } else {
            message.error(res?.message || "Failed to fetch estimation stats")
        }
    }
    catch (err) {
        message.error("Error fetching estimation stats")
    }
}

const shortText = (text, maxLength = 20) => {
    if (!text) return ''
    return text.length > maxLength ? text.slice(0, maxLength) + '…' : text
}



function getClockStatus(workLogs) {
    // const today = "2025-10-16";
    const today = moment().tz("Europe/Rome").format("YYYY-MM-DD");

    // find today's log
    const todayLog = workLogs.find(log =>
        moment(log.work_day).format("YYYY-MM-DD") === today && !log.is_deleted
    );

    // ✅ No record for today
    if (!todayLog) {
        return "show-clockin";
    }
    if (todayLog?.status === 'missed') {
        return "show-missed";
    }

    // ✅ Both entry and exit present
    if (todayLog.entry_time && todayLog.exit_time) {
        return "done";
    }

    // ✅ Entry exists but no exit
    if (todayLog.entry_time && !todayLog.exit_time) {
        return "show-clockout";
    }

    // ✅ No entry (shouldn’t happen, but fallback)
    return "show-clockin";
}


function getTodayLogEntryTime(workLogs) {
    const today = moment().format("YYYY-MM-DD");
    const todayLog = workLogs.find(log =>
        moment(log.work_day).format("YYYY-MM-DD") === today && !log.is_deleted
    );
    if (todayLog?.entry_time) {
        return todayLog.entry_time;
    } else {
        return null
    }
}


const validateBreakTimesAdminAddLogs = (breaks, entry, exit) => {
    if (!Array.isArray(breaks)) return null;

    for (let i = 0; i < breaks.length; i++) {
        const b = breaks[i];
        if (!b.start || !b.end)
            return `Please provide both start and end time for Break ${i + 1}`;

        if (b.start.isSame(b.end)) {
            return `Break ${i + 1}: Start and end time cannot be the same`;
        }
        if (b.start.isAfter(b.end)) {
            return `Break ${i + 1}: Start time must be before end time`;
        }

        // must be within entry–exit range
        if (b.start.isBefore(entry) || b.end.isAfter(exit)) {
            return `Break ${i + 1}: must be within working hours (${entry.format(
                "HH:mm"
            )}–${exit.format("HH:mm")})`;
        }

        // check overlap with other breaks
        for (let j = 0; j < breaks.length; j++) {
            if (i === j) continue;
            const other = breaks[j];
            if (!other.start || !other.end) continue;

            const overlap =
                b.start.isBetween(other.start, other.end, null, "[)") ||
                b.end.isBetween(other.start, other.end, null, "(]") ||
                other.start.isBetween(b.start, b.end, null, "[)");
            if (overlap) {
                return `Break ${i + 1} overlaps with Break ${j + 1}`;
            }
        }
    }

    return null; // ✅ means all clear
};


const timeToSeconds = (time) => {
    const parts = time.split(':').map(Number)

    // supports mm:ss or hh:mm:ss
    if (parts.length === 2) {
        const [m, s] = parts
        return m * 60 + s
    }

    const [h, m, s] = parts
    return h * 3600 + m * 60 + s
}

const secondsToHMSLabel = (seconds) => {
    const h = Math.floor(seconds / 3600)
    const m = Math.floor((seconds % 3600) / 60)
    const s = seconds % 60
    return `${h}h ${m}m ${s}s`
}

const convertToHoursMinutes = (time) => {
    const totalMinutes = Math.round(time * 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${hours}h ${minutes}m`;
}
export {
    verifyToken,
    fetchEmployeeLog,
    fetchEmployeeName,
    fetchEstimations,
    fetchStats,
    shortText,
    getClockStatus,
    getTodayLogEntryTime,
    validateBreakTimesAdminAddLogs,
    secondsToHMSLabel,
    timeToSeconds,
    updateFcmToken,
    convertToHoursMinutes
}